import Sider from 'antd/es/layout/Sider';

export default Sider;
